export default "__VITE_ASSET__45868b90__"